import _implicitStylesheets from "./qualifiedChat.css";
import _implicitScopedStylesheets from "./qualifiedChat.scoped.css?scoped=true";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  return stc0;
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5lg61lcreqd";
tmpl.legacyStylesheetToken = "undefined-_qualifiedChat";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
